import React, { useEffect, useContext } from "react";
import { ContextProvider } from "../../App";

import { NavLink } from "react-router-dom";
import Styles from "./OrderSummery.module.css";
import axios from "axios";
import Footer from "../../common/Footer";
import AuthorizedHeader from "../../common/authorized/AuthorizedHeader";
import Header from "../../common/Header";

function OrderSummery() {
  const { orderState, orderDispatch,isMobile,authState } = useContext(ContextProvider);

  const getAllOrders = async () => {
    try {
      const response = await axios.get("/api/v1/orders");
      orderDispatch({ type: "FETCH_ALL_ORDERS", payload: response.data.body });
    } catch (error) {
      console.log("Error while fetching orders ", error);
    }
  };

  useEffect(() => {
    getAllOrders();
  }, []);

  return (
    <>
       <div>
        {authState.loggedIn === true ? <AuthorizedHeader /> : <Header />}
      </div>
      <div>
      {orderState.allOrders.map((item) => {
        return (
          <NavLink
            to={`/food/order-summery/${item._id}`}
            style={{ textDecoration: "none", color: "#000" }}
            key={item._id}
            >
            <div className={Styles.order_summery_container}>
              <div className={Styles.order_summery_box}>
                <div className={Styles.order_name_box}>
                  <h3 className={Styles.order_schoolName}>
                    {item.shipping.schoolName}
                  </h3>
                  <h3 className={Styles.order_parentName}>
                    {item.shipping.parentName}
                  </h3>
                </div>
                        <h3 className={Styles.order_amount}>
                            { item.subscription === "montly" && "NOK 200"}
                            { item.subscription === "weekly" && "NOK 50"}
                            { item.subscription === "daily" && "NOK 10"}
                  </h3>
              </div>
            </div>
          </NavLink>
        );
          })}
         </div>
      <div className={ Styles.footer_order}>
      <Footer footerWidth={isMobile ? "100%" : "75%"} />
      </div>
    </>
  );
}

export default OrderSummery;
